import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BillOfQuantitiesDbTableDefinition } from '../../bill-of-quantities-positions/dao/bill-of-quantities-positions-dao/bill-of-quantities-positions-db-table-definition';
import { BranchTypesDbTableDefinition } from '../../branch-types/dao/branch-types-dao/branch-types-db-table-definition';
import { LocalBranchTypesDbTableDefinition } from '../../branch-types/dao/branch-types-dao/local-branch-types-db-table-definition';
import { BranchDbTableDefinition } from '../../branches/dao/branches-dao/branches-db-table-definition';
import { LocalBranchDbTableDefinition } from '../../branches/dao/branches-dao/local-branches-db-table-definition';
import { CargoItemTypeDbTableDefinition } from '../../cargo-item-types/dao/cargo-item-types-dao/cargo-item-types-db-table-definition';
import { CargoItemDbTableDefinition } from '../../cargo-item/dao/cargo-item-dao/cargo-item-db-table-definition';
import { LocalCargoItemDbTableDefinition } from '../../cargo-item/dao/cargo-item-dao/local-cargo-item-db-table-definition';
import { CarDbTableDefinition } from '../../cars/dao/cars-dao/car-db-table-definition';
import { DynFormDataDbTableDefinition } from '../../dyn-forms/dao/dyn-form-data/dyn-form-data-dao/dyn-form-data-db-table-definition';
import { DynFormDbTableDefinition } from '../../dyn-forms/dao/dyn-form/dyn-forms-dao/dyn-form-db-table-definition';
import { EmployeeDbTableDefinition } from '../../employee/dao/employee-dao/employee-db-table-definition';
import { TeamEmployeeDbTableDefinition } from '../../employee/dao/employee-dao/team-employee-db-table-definition';
import { EquipmentDbTableDefinition } from '../../equipments/dao/equipments-dao/equipment-db-table-definition';
import { LocalEquipmentDbTableDefinition } from '../../equipments/dao/equipments-dao/local-equipment-db-table-definition';
import { ExtFileDbTableDefinition } from '../../ext-files/dao/ext-files-dao/ext-file-db-table-definition';
import { JobSectionDbTableDefinition } from '../../job-section/dao/job-section-dao/job-section-db-table-definition';
import { LoggingDbTableDefinition } from '../../logging/dao/logging-db-dao/logging-db-table-definition';
import { MaterialDbTableDefinition } from '../../materials/dao/materials-dao/material-db-table-definition';
import { LocalOrderItemDbTableDefinition } from '../../order-item/dao/order-item-dao/local-order-item-db-table-definition';
import { OrderItemDbTableDefinition } from '../../order-item/dao/order-item-dao/order-item-db-table-definition';
import { LocalPinTypeDbTableDefinition } from '../../pin-types/dao/pin-types-dao/local-pin-type-db-table-definition';
import { PinTypeDbTableDefinition } from '../../pin-types/dao/pin-types-dao/pin-type-db-table-definition';
import { LocalPinDbTableDefinition } from '../../pins/dao/pins-dao/local-pin-db-table-definition';
import { PinDbTableDefinition } from '../../pins/dao/pins-dao/pin-db-table-definition';
import { ReasonDbTableDefinition } from '../../reasons/dao/reasons-dao/reason-db-table-definition';
import { RemoteActionDbTableDefinition } from '../../remote-action/dao/remote-action-db-dao/remote-action-db-table-definition';
import { TransmittedRemoteActionDbTableDefinition } from '../../remote-action/dao/transmitted-remote-action-db-dao/transmitted-remote-action-db-table-definition';
import { LocalServicejobDbTableDefinition } from '../../servicejobs/dao/servicejobs-dao/local-servicejobs-db-table-definition';
import { ServicejobDbTableDefinition } from '../../servicejobs/dao/servicejobs-dao/servicejobs-db-table-definition';
import { TagTemplatesElementDbTableDefinition } from '../../tag-templates-elements/dao/tag-templates-elements-dao/tag-templates-element-db-table-definition';
import { TagTemplateDbTableDefinition } from '../../tag-templates/dao/tag-templates-dao/tag-template-db-table-definition';
import { TourStopDbTableDefinition } from '../../tour-stop/dao/tour-stop-dao/tour-stop-db-table-definition';
import { TourDbTableDefinition } from '../../tour/dao/tour-dao/tour-db-table-definition';
import { DbPersistenceService } from './db-persistence.service';
import { DbTableDefinition } from './db-table-definition';
import { DeficiencyTicketDbTableDefinition } from '../../deficiency-ticket/dao/deficiency-tickets/deficiency-tickets-db-table-definition';
import { LocalDeficiencyTicketDbTableDefinition } from '../../deficiency-ticket/dao/deficiency-tickets/local-deficiency-tickets-db-table-definition';
import { PeripheralDbTableDefinition } from '../../peripherals/dao/peripherals-dao/peripheral-db-table-definition';
import { MaterialDemandDbTableDefinition } from '../../materialdemandinfo/dao/material-demand-dao/material-demand-db-table-definition';
import { MaterialDemandPositionDbTableDefinition } from '../../materialdemandinfo/dao/material-demand-position-dao/material-demand-position-db-table-definition';
import { MaterialDeliveriesDbTableDefinition } from '../../materialdemandinfo/dao/material-delivery-dao/material-delivery-db-table-definition';
import { MessageDbTableDefinition } from '../../message/dao/message-dao/message-db-table-definition';
import { LocalExtFileDbTableDefinition } from '../../ext-files/dao/ext-files-dao/local-ext-file-db-table-definition';
import { CellphoneDbTableDefinition } from '../../cellphones/dao/cellphones-dao/cellphone-db-table-definition';
import { ProjectContactDirectoryDbTableDefinition } from '../../project-contact-directory/dao/project-contact-directory-dao/project-contact-directory-db-table-definition';
import { LocalProjectContactDirectoryDbTableDefinition } from '../../project-contact-directory/dao/project-contact-directory-dao/local-project-contact-directory-db-table-definition';
import { PersonsDbTableDefinition } from '../../persons/dao/persons-dao/persons-db-table-definition';
import { LocalPersonsDbTableDefinition } from '../../persons/dao/persons-dao/local-persons-db-table-definition';
import { LocalPersonOverridesDbTableDefinition } from '../../persons/dao/persons-dao/local-person-overrides-db-table-definition';
import { BranchFunctionGroupsDbTableDefinition } from '../../branch-function-groups/dao/branch-function-groups-dao/branch-function-groups-db-table-definition';
import { LocalBranchFunctionGroupsDbTableDefinition } from '../../branch-function-groups/dao/branch-function-groups-dao/local-branch-function-groups-db-table-definition';
import { EmployeeFunctionGroupsDbTableDefinition } from '../../employee-function-groups/dao/employee-function-groups-dao/employee-function-groups-db-table-definition';
import { LocalEmployeeFunctionGroupsDbTableDefinition } from '../../employee-function-groups/dao/employee-function-groups-dao/local-employee-function-groups-db-table-definition';
import { DeficiencyTicketWatchersDbTableDefinition } from '../../deficiency-ticket-watchers/dao/deficiency-ticket-watchers-dao/deficiency-ticket-watchers-db-table-definition';
import { LocalDeficiencyTicketWatchersDbTableDefinition } from '../../deficiency-ticket-watchers/dao/deficiency-ticket-watchers-dao/local-deficiency-ticket-watchers-db-table-definition';
import { ActivityConfirmationsDbTableDefinition } from '../../activity-confirmations/dao/activity-confirmations-dao/activity-confirmations-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: DbTableDefinition,
      useExisting: BillOfQuantitiesDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: BranchTypesDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalBranchTypesDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: BranchDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalBranchDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: CargoItemDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalCargoItemDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: CargoItemTypeDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: CarDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: DynFormDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: DynFormDataDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: EmployeeDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: TeamEmployeeDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: EquipmentDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalEquipmentDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: ExtFileDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: JobSectionDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: MaterialDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: OrderItemDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalOrderItemDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: PinTypeDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalPinTypeDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: PinDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalPinDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: ReasonDbTableDefinition,
      multi: true,
    },

    {
      provide: DbTableDefinition,
      useExisting: RemoteActionDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: TransmittedRemoteActionDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: ServicejobDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalServicejobDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: TagTemplateDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: TagTemplatesElementDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: TourDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: TourStopDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: DeficiencyTicketDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalDeficiencyTicketDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: PeripheralDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: MaterialDemandDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: MaterialDemandPositionDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: MaterialDeliveriesDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: MessageDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalExtFileDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: CellphoneDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: ProjectContactDirectoryDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalProjectContactDirectoryDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: PersonsDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalPersonsDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalPersonOverridesDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: BranchFunctionGroupsDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalBranchFunctionGroupsDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: EmployeeFunctionGroupsDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalEmployeeFunctionGroupsDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: DeficiencyTicketWatchersDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: LocalDeficiencyTicketWatchersDbTableDefinition,
      multi: true,
    },
    {
      provide: DbTableDefinition,
      useExisting: ActivityConfirmationsDbTableDefinition,
      multi: true,
    },
    DbPersistenceService,
  ],
})
export class DbPersistenceModule {}
